<div class="idp-tab-container">
  <idp-tab-headers
    *ngIf="true"
    (selectedTab)="setCurrentTab($event)"
    [config]="headerData.config"
    [content]="headerData.content"
  ></idp-tab-headers>
  <ng-content></ng-content>
  <idp-tab-headers
    *ngIf="false"
    [config]="headerData.config"
    [content]="headerData.content"
  ></idp-tab-headers>
</div>
